<template>
  <v-dialog v-model="dialogShow" persistent width="960" class="dialog">
    <v-card>
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">请选择想创作的内容</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="height:367px;padding:0;font-size:14px;color:#000000;">

        <div style="padding:0 8px;display:flex;">
          <div @click="clickSceneType(item)" @mouseenter="changeShowGif(item.name)" @mouseleave="changeShowGif('')"
               v-for="(item,index) in sceneTypeList" :key="'sceneType'+index"
               :style="{'border':$store.state.sceneType === item.name ? '2px solid #2A82E4' : '2px solid transparent'}"
               style="width:220px;height:254px;margin:16px 8px;padding:10px;border-radius:5px;font-size:16px;cursor:pointer;">
            <img v-show="!item.showGif" :src="item.picture" style="width:100%;height:140px;border-radius:5px;">
            <img v-show="item.showGif" :src="item.gifPicture" style="width:100%;height:140px;border-radius:5px;">
            <p style="margin-top:8px;line-height:22px;">{{item.name}}</p>
            <p style="margin-top:8px;line-height:22px;text-align:justify;">{{item.introduce}}</p>
          </div>
        </div>

        <div style="margin-top:25px;padding:0 16px;display:flex;align-items:center;">
          <p style="color:#2A82E4;font-size:16px;cursor:pointer;">浏览社区，观看更多精彩创作</p>
          <v-spacer></v-spacer>
          <v-btn @click="chooseSceneTypeOk" width="100" height="35" dark color="#1E3A8A">下一步</v-btn>
        </div>


      </v-card-text>


    </v-card>

  </v-dialog>

</template>

<script>
export default {
  name: "ChooseSceneType",
  data(){
    return{
      sceneTypeList:[
        {
          picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310311705000044233.jpg",
          gifPicture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202311090917000138302.gif",
          name:"单点动画",
          introduce:"选取单个点位完成特定目标的地球动画",
          showGif:false,
        },
        {
          picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310311705000266195.jpg",
          gifPicture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202311090917000138302.gif",
          name:"多点跳转",
          introduce:"选取多个点位进行点位之间的动画跳转",
          showGif:false,
        },
        {
          picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310311705000405858.jpg",
          gifPicture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202311090917000138302.gif",
          name:"地球动画",
          introduce:"体验地球旋转、俯冲等定制动画",
          showGif:false,
        },
        {
          picture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/20231031170500053509.jpg",
          gifPicture:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202311090917000138302.gif",
          name:"自定义动画",
          introduce:"自定义点位数量及动画效果",
          showGif:false,
        },


      ]


    }

  },
  props:["dialogShow"],
  methods:{
    closeDialog(){
      this.$store.state.sceneType = "自定义动画";
      this.$emit("closeDialog","")
    },

    //点击某项type
    clickSceneType(item){
      this.$store.state.sceneType = item.name;
      this.changeShowGif(item.name);
    },
    //修改类型列表的展示gif效果
    changeShowGif(currName){
      for(let i=0;i<this.sceneTypeList.length;i++){
        if(this.sceneTypeList[i].name === this.$store.state.sceneType || this.sceneTypeList[i].name === currName){
          this.sceneTypeList[i].showGif = true;
        }
        else{
          this.sceneTypeList[i].showGif = false;
        }
      }
    },

    //下一步
    chooseSceneTypeOk(){
      this.$emit("chooseSceneTypeOk","")
    }

  },
  mounted(){
    this.$store.state.sceneType = "单点动画";
    this.changeShowGif();
  }


}
</script>

<style scoped>

</style>